import { render, staticRenderFns } from "./weixin-login.vue?vue&type=template&id=29a34c6a&scoped=true&"
import script from "./weixin-login.vue?vue&type=script&lang=jsx&"
export * from "./weixin-login.vue?vue&type=script&lang=jsx&"
import style0 from "./weixin-login.vue?vue&type=style&index=0&id=29a34c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a34c6a",
  null
  
)

export default component.exports